var React = require('react');

function QuickbooksLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M60 30A30 30 0 1 1 30 0a30 30 0 0 1 30 30z","fill":"#24a205","key":0}),React.createElement("path",{"d":"M51.22 30a12 12 0 0 0-11.96-12h-1.09v4.2h1.09a7.75 7.75 0 1 1 0 15.5h-3.75V12.25h-4.19v29.68h7.94A12 12 0 0 0 51.22 30zM28.65 18h-8a12 12 0 0 0 0 23.9h1.1v-4.2h-1.1a7.75 7.75 0 0 1 0-15.5h3.76v25.51h4.2z","fill":"#f4f4f4","key":1})]);
}

QuickbooksLogo.defaultProps = {"viewBox":"0 0 60 60","role":"img"};

module.exports = QuickbooksLogo;

QuickbooksLogo.default = QuickbooksLogo;
